import React, {useRef, useState, useEffect} from 'react';
import {Form} from "react-bootstrap";
import {Button} from "@gravity-ui/uikit";
import {PhoneInput} from 'react-international-phone';
import 'react-international-phone/style.css';
import UserCard from "../../components/userCard/UserCard";
import {Pencil} from "@gravity-ui/icons";
import UniversitySelect from "../../components/UniversitySelect";
import CitySelect from "../../components/CitySelect";
import {ALL_UNIVERSITIES} from "../../components/Universities";
import {ALL_CITIES} from "../../components/Cities";

const VALID_POSITIONS = ['Студент', 'Школьник', 'Прочее'];

function UserForm({onSubmit, submitting, userData, setUserData, errors}) {
    const [selectedImage, setSelectedImage] = useState("");
    const [selectedRole, setSelectedRole] = useState('');
    const [isCustomUniversity, setIsCustomUniversity] = useState(false);
    const [isCustomCity, setIsCustomCity] = useState(false);

    const filePicker = useRef(null);

    useEffect(() => {
        if (userData.position) {
            const role = VALID_POSITIONS.includes(userData.position) ? userData.position : 'Прочее';
            setSelectedRole(role);
            if (role === 'Студент') {
                const wp = userData.workplace || '';
                setIsCustomUniversity(!!wp && !ALL_UNIVERSITIES.includes(wp));
            }
        }
        if (userData.address) {
            setIsCustomCity(!ALL_CITIES.includes(userData.address));
        }
    }, [userData.position, userData.address]);

    const onPick = () => filePicker.current.click();

    const onChangeAvatar = (e) => {
        setUserData(prev => ({...prev, [e.target.name]: e.target.files[0]}));
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
    };

    const onChange = (e) => {
        setUserData(prev => ({...prev, [e.target.name]: e.target.value}));
    };

    const handleRoleChange = (role) => {
        if (selectedRole) {
            setUserData(prev => ({...prev, workplace: ''}));
        }
        setSelectedRole(role);
        setIsCustomUniversity(false);
        setUserData(prev => ({...prev, position: role}));
    };

    const getUniversitySelectStyles = () => ({
        menu: (provided) => ({...provided, zIndex: 10001}),
        menuPortal: (provided) => ({...provided, zIndex: 10001}),
        container: (provided) => ({...provided, zIndex: 10001, position: 'relative'}),
    });

    const getCitySelectStyles = () => ({
        menu: (provided) => ({...provided, zIndex: 10000}),
        menuPortal: (provided) => ({...provided, zIndex: 10000}),
        container: (provided) => ({...provided, zIndex: 10000, position: 'relative'}),
    });

    return (
        <Form onSubmit={onSubmit}>
            <div className="row d-flex flex-column-reverse flex-lg-row">
                <div className="col-lg-9 mt-lg-0 mt-3">

                    <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Label className="required">Электронная почта</Form.Label>
                        <Form.Control required type="email" name="email"
                                      value={userData.email} onChange={onChange}
                                      isInvalid={!!(errors && errors.email)}/>
                        <Form.Control.Feedback type="invalid">{errors && errors.email}</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formLastname" className="mb-3">
                        <Form.Label className="required">Фамилия</Form.Label>
                        <Form.Control required type="text" name="last_name"
                                      value={userData.last_name || ''} onChange={onChange}/>
                    </Form.Group>

                    <Form.Group controlId="formFirstname" className="mb-3">
                        <Form.Label className="required">Имя</Form.Label>
                        <Form.Control required type="text" name="first_name"
                                      value={userData.first_name || ''} onChange={onChange}/>
                    </Form.Group>

                    <Form.Group controlId="formMiddlename" className="mb-3">
                        <Form.Label>Отчество</Form.Label>
                        <Form.Control type="text" name="middle_name"
                                      value={userData.middle_name || ''} onChange={onChange}/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Кто пользователь?</Form.Label>
                        <div className="d-flex gap-4 mt-1">
                            {VALID_POSITIONS.map(role => (
                                <Form.Check
                                    key={role}
                                    type="radio"
                                    id={`admin-role-${role}`}
                                    label={role}
                                    name="admin-role"
                                    checked={selectedRole === role}
                                    onChange={() => handleRoleChange(role)}
                                />
                            ))}
                        </div>
                    </Form.Group>

                    {selectedRole && (
                        <Form.Group controlId="formWorkplace" className="mb-3">
                            <Form.Label>
                                {selectedRole === 'Студент' ? 'ВУЗ' : selectedRole === 'Школьник' ? 'Школа' : 'Место работы / должность'}
                            </Form.Label>
                            {selectedRole === 'Студент' ? (
                                <>
                                    <div className="form-check mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="adminIsCustomUniversity"
                                            checked={isCustomUniversity}
                                            onChange={(e) => {
                                                setIsCustomUniversity(e.target.checked);
                                                setUserData(prev => ({...prev, workplace: ''}));
                                            }}
                                        />
                                        <label className="form-check-label" htmlFor="adminIsCustomUniversity">
                                            ВУЗа нет в списке
                                        </label>
                                    </div>
                                    {isCustomUniversity ? (
                                        <Form.Control
                                            type="text"
                                            name="workplace"
                                            value={userData.workplace || ''}
                                            onChange={onChange}
                                            placeholder="Введите название ВУЗа"
                                        />
                                    ) : (
                                        <UniversitySelect
                                            value={userData.workplace || ''}
                                            onChange={(value) => setUserData(prev => ({...prev, workplace: value}))}
                                            placeholder="Начните вводить название ВУЗа..."
                                            classNamePrefix="bmm-select"
                                            styles={getUniversitySelectStyles()}
                                        />
                                    )}
                                </>
                            ) : (
                                <Form.Control
                                    type="text"
                                    name="workplace"
                                    value={userData.workplace || ''}
                                    onChange={onChange}
                                    placeholder={selectedRole === 'Школьник' ? 'Например: Лицей №1535' : 'Например: Яндекс / Разработчик'}
                                />
                            )}
                        </Form.Group>
                    )}

                    <Form.Group controlId="formBirthday" className="mb-3">
                        <Form.Label>Дата рождения</Form.Label>
                        <Form.Control
                            type="date"
                            name="birth_date"
                            value={userData.birth_date || ''}
                            onChange={onChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="formAddress" className="mb-3">
                        <Form.Label>Город проживания</Form.Label>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="adminIsCustomCity"
                                checked={isCustomCity}
                                onChange={(e) => {
                                    setIsCustomCity(e.target.checked);
                                    setUserData(prev => ({...prev, address: ''}));
                                }}
                            />
                            <label className="form-check-label" htmlFor="adminIsCustomCity">
                                Города нет в списке
                            </label>
                        </div>
                        {isCustomCity ? (
                            <Form.Control
                                type="text"
                                name="address"
                                value={userData.address || ''}
                                onChange={onChange}
                                placeholder="Введите название города"
                            />
                        ) : (
                            <CitySelect
                                value={userData.address || ''}
                                onChange={(value) => setUserData(prev => ({...prev, address: value}))}
                                placeholder="Выберите город..."
                                classNamePrefix="bmm-select"
                                styles={getCitySelectStyles()}
                            />
                        )}
                    </Form.Group>

                    <Form.Group controlId="formContact" className="mb-3">
                        <Form.Label>Контакты</Form.Label>
                        <Form.Control
                            type="text"
                            name="contact"
                            value={userData.contact || ''}
                            onChange={onChange}
                            placeholder="Telegram, VK, MAX..."
                        />
                    </Form.Group>

                    <Form.Group controlId="formPhoneNumber" className="mb-3">
                        <Form.Label>Номер телефона</Form.Label>
                        <PhoneInput
                            defaultCountry="ru"
                            inputProps={{name: "phone_number"}}
                            value={userData.phone_number || ''}
                            onChange={(value) => setUserData(prev => ({...prev, phone_number: value}))}
                            style={{zIndex: 1}}
                        />
                    </Form.Group>

                    <Button view="action" type="submit" disabled={submitting} className="mt-3 w-100" size="l">
                        {submitting ? 'Сохранение...' : 'Сохранить'}
                    </Button>
                </div>
                <div className="col-lg-3">
                    <Form.Label>Изображение профиля</Form.Label>
                    <Form.Control className="hidden" name="avatar" type="file" ref={filePicker} accept="image/*"
                                  onChange={onChangeAvatar}/>
                    <div className="avatar-upload position-relative" role="button" onClick={onPick}>
                        <UserCard size="l" imgUrl={selectedImage || userData.avatar}
                                  name={`${userData.last_name || ''} ${userData.first_name || ''}`}
                                  initialsOnly={true}/>
                        <span className="avatar-upload__button">
                            <Pencil/> Изменить
                        </span>
                    </div>
                </div>
            </div>
        </Form>
    );
}

export default UserForm;
